// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1PK0M","header":"MergedInvoice_header__1ey3y"};